// extracted by mini-css-extract-plugin
export var hidden = "_uj-0";